import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom'; // Added useLocation
import { useAuth } from '../context/AuthContext';
import {
  RiDashboardLine,
  RiMedicineBottleLine,
  RiBuildingLine,
  RiFileEditLine,
  RiMailLine,
  RiSettingsLine,
  RiLogoutBoxLine,
  RiMenuLine,
  RiCloseLine,
  RiNewsLine
} from 'react-icons/ri';
import './../styles/admin.css';

const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); 
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    { path: 'dashboard', icon: <RiDashboardLine />, label: 'Dashboard' },
    { path: 'products', icon: <RiMedicineBottleLine />, label: 'Products' },
    { path: 'sponsors', icon: <RiBuildingLine />, label: 'Partners' },
    { path: 'content', icon: <RiFileEditLine />, label: 'Content' },
    { path: 'news', icon: <RiNewsLine />, label: 'Stories' },
    { path: 'Messages', icon: <RiMailLine />, label: 'Messages' },
    { path: 'settings', icon: <RiSettingsLine />, label: 'Settings' },
  ];

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2 className="admin-logo">
            <img src="/assets/img/logo.png" alt="Admin Logo" />
            <span>Admin Panel</span>
          </h2>
          <button 
            className="sidebar-toggle" 
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
          >
            {sidebarOpen ? <RiCloseLine /> : <RiMenuLine />}
          </button>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => {
            const isActive = location.pathname === `/admin/${item.path}` || 
                           location.pathname === `/admin/${item.path}/`;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-nav-link ${isActive ? 'active' : ''}`}
                onClick={() => window.innerWidth < 1024 && setSidebarOpen(false)}
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="nav-icon">{item.icon}</span>
                {sidebarOpen && <span className="nav-label">{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn" aria-label="Logout">
            <RiLogoutBoxLine />
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>
      
      <main className="admin-main">
        <header className="admin-header">
          <div className="header-left">
            <button 
              className="mobile-menu-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-label="Toggle menu"
            >
              <RiMenuLine />
            </button>
            <h1>Admin Dashboard</h1>
          </div>
          <div className="header-right">
            <div className="admin-profile">
              <img 
                src="/assets/img/admin-avatar.png" 
                alt="Admin" 
                className="admin-avatar"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Ccircle cx='20' cy='20' r='20' fill='%23667eea'/%3E%3Ctext x='20' y='25' text-anchor='middle' fill='white' font-size='16' font-family='Arial'%3EA%3C/text%3E%3C/svg%3E";
                }}
              />
              <span>Admin User</span>
            </div>
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;